export const QUICK_ADD_TO_CART_TIMEOUT = 1500;
